angular
    .module('valueconnectApp')
    .component('vcFooter', {
        templateUrl: 'app/components/footer/vc-footer.html',
        controller: ['$rootScope', '$scope', VcFooter]
    });

function VcFooter($rootScope, $scope){
}
